function HamburgerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
      <path d="M17 31C17 30.4477 17.4477 30 18 30H36C36.5523 30 37 30.4477 37 31C37 31.5523 36.5523 32 36 32H18C17.4477 32 17 31.5523 17 31Z" fill="#b1b1b1"/>
      <path d="M17 26C17 25.4477 17.4477 25 18 25H36C36.5523 25 37 25.4477 37 26C37 26.5523 36.5523 27 36 27H18C17.4477 27 17 26.5523 17 26Z" fill="#b1b1b1"/>
      <path d="M17 21C17 20.4477 17.4477 20 18 20H36C36.5523 20 37 20.4477 37 21C37 21.5523 36.5523 22 36 22H18C17.4477 22 17 21.5523 17 21Z" fill="#b1b1b1"/>
    </svg>

  )
}
export default HamburgerIcon